/**
 * One-paragraph plain text from markdown, for previews that clamp to a
 * line or two: the first block before any heading, with inline syntax
 * (emphasis, code, links, images) reduced to its text.
 */
export function markdownPreview(markdown: string | null | undefined): string {
  if (!markdown) return "";
  const beforeHeading = markdown.split(/^#{1,6}\s/m)[0] ?? "";
  return beforeHeading
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/(\*\*|__)(.+?)\1/g, "$2")
    .replace(/(\*|_)(.+?)\1/g, "$2")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/^\s*[-*+>]\s+/gm, "")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * The first sentence of a paragraph — the gist of a judge's reasoning,
 * shown before the full text. A sentence ends at . ! or ? followed by
 * whitespace or the end, so "3.5", "e.g.x" or a URL do not cut it short.
 */
export function firstSentence(text: string | null | undefined): string {
  if (!text) return "";
  const m = text.match(/^[\s\S]*?[.!?](?=\s|$)/);
  return (m ? m[0] : text).trim();
}
